import Error from '../model/Error';
import Field from '../dto/resource/Field';
import axios from 'axios';

export default class FieldRepository {

    static findAllByLocationIdAndAreaId(locationId, areaId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/resources/locations/${locationId}/areas/${areaId}/fields`)
                .then(response => resolve(response.data.data.map(data => Field.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static find(locationId, areaId, fieldId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/resources/locations/${locationId}/areas/${areaId}/fields/${fieldId}`)
                .then(response => resolve(Field.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }


    static create(field, areaId, locationId) {
        const data = {
            name: field.name,
            size: field.size !== '' ? parseInt(field.size) : null,
            maxPersons: field.maxPersons !== '' ? parseInt(field.maxPersons) : null,
            note: field.note,
        };

        return new Promise((resolve, reject) => {
            axios
                .post(`/club/resources/locations/${locationId}/areas/${areaId}/fields`, data)
                .then(response => resolve(response.headers['x-identifier']))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }


    static update(field, areaId, locationId) {
        const data = {
            name: field.name,
            size: field.size !== '' ? parseInt(field.size) : null,
            maxPersons: field.maxPersons !== '' ? parseInt(field.maxPersons) : null,
            note: field.note,
        };

        return new Promise((resolve, reject) => {
            axios
                .put(`/club/resources/locations/${locationId}/areas/${areaId}/fields/${field.id}`, data)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(locationId, areaId, fieldId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/resources/locations/${locationId}/areas/${areaId}/fields/${fieldId}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static archive(locationId, areaId, fieldId) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/club/resources/locations/${locationId}/areas/${areaId}/fields/${fieldId}/archived`, {
                    archived: true,
                })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static uploadImage(locationId, areaId, fieldId, image, progressCallback) {
        const config = {
            onUploadProgress: function(progressEvent) {
                if (progressCallback) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    progressCallback(percentCompleted);
                }
            },
            headers: { 'Content-Type': 'application/octet-stream' }
        };

        return new Promise((resolve, reject) => {
            axios
                .put(`/club/resources/locations/${locationId}/areas/${areaId}/fields/${fieldId}/image`, image, config)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static removeImage(locationId, areaId, fieldId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/resources/locations/${locationId}/areas/${areaId}/fields/${fieldId}/image`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
